/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService, TimeService, UNPLACEHOLDER } from '@dm/core';

export enum objectTypeE {
    block = '0',
    file = '1'
}

@Injectable({ providedIn: 'any' })
export class CreateStrService {
    table = {
        createBtn: this.get('common.create_button'),
        previousBtn: this.get('common.previous_button'),
        nextBtn: this.get('common.next_button'),
        okBtn: this.get('common.confirm_button'),
        cancelBtn: this.get('common.cancel_button'),
        confirmBtn: this.get('common.confirm_button'),
        activateBtn: this.get('common.start_now_checkbox'),
        closeBtn: this.get('common.close_button'),
    };
    title = {
        basicInfo: this.get('common.basicInfo_title'),
        schedule: this.get('common.plan_title'),
        activateMsg : this.get('rest.startHyperCDPSchedule_msg'),
        appliedLUN: this.get('protection.HyperCDPSchedule_task_create_step3_applyLun_label'),
        appliedPG: this.get('protection.HyperCDPSchedule_task_create_step3_applyPG_label'),
        appliedFS: this.get('protection.HyperCDPSchedule_task_create_step3_applyFS_label'),
        executedPolicy: this.get('protection.HyperCDPSchedule_term_executePolicy_cloum'),
        createTitle: this.get('protection.HyperCDPSchedule_task_create_title'),
        specifyObj: this.get('protection.HyperCDPSchedule_task_create_step1_selectObject_title'),
        configPolicy: this.get('protection.HyperCDPSchedule_task_create_step2_config_title'),
        confirm: this.get('common.confirm_lab'),
        name: this.get('common.name_column'),
        id: this.get('common.ID_column'),
        capacity: this.get('common.capacity_column'),
        wwn: this.get('common.device_WWN_label'),
        description: this.get('description_column'),
        addMember: this.get('common.addMember_button'),
        removeMember: this.get('common.removeMember_button'),
        lun: this.get('common.lun_title'),
        pg: this.get('protection.protectionGroups_title'),
        type: this.get('common.type_column'),
        vStoreLab: this.get('common.owningVstore_lab'),
        timePolicyLab: this.get('settings.Antivirus_task_oneDemandScanPolicy_timePolicy_PeriodPolicy_lab'),
        detailSnapshotTag: this.get('protection.replicaiton_task_createAsync_userSnapSync_Tag_lab', true),
    };
    create = {
        wormTab: this.get('protection.HyperCDPSchedule_task_create_step2_secureSnap_lab'),
        enableAutoDelete: this.get('service.filesystem_task_create_worm_para_enableAutoDelete_checkbox'),
        protectTime: this.get('service.filesystem_task_create_worm_para_protectTime_value_min_label'),
        enableLab: this.get('common.enable_label'),
        createHighRisk: this.get('protection.dataProtection_term_HyperCDP_SCHEDULE_createSecureSnap_msg'),
        createFsHighRisk: this.get('protection.dataProtection_term_FSHyperCDP_SCHEDULE_createSecureSnap_msg'),
        limitedNumHighRisk: this.get('protection.HyperCDPSchedule_task_create_confirm_msg'),
    };
    colon = this.get('common.colon_label');
    UNPLACEHOLDER = UNPLACEHOLDER;
    executeResult_taskDetail_info = this.i18nService.get('common.executeResult_taskDetail_info');

    constructor(
        private i18nService: I18nService,
        private time: TimeService,
    ) { }

    get(key: string, params?: any[] | boolean, colon?: boolean): string {
        return this.i18nService.get(key, params, colon);
    }
    renderTime(time: number): string {
        return time === 0 ?
            UNPLACEHOLDER :
            this.time.formatUTC(time * 1e3);
    }

    isEn(): boolean {
        return this.i18nService.language === 'en';
    }

    /**
     * 创建结果
     * @param name
     */
    createResult(name: string): string {
        return this.get('rest.create_hyperCDPSchedule_msg', [name]);
    }
}
